<template>
  <div>
    <div class="scroll-wrapper">
      <b-card style="border:none !important; box-shadow: none !important; outline: none !important;" class="scroll">
        <div :class="{ 'card-container': !hasComparisonData, 'card-container-after': hasComparisonData }">
          <div class="product-comparison">
            <div class="comparison-table">
              <div class="product-headers" style="margin-bottom:20px !important">
                <div v-if="hasComparisonData" class="product-header" 
                  style="
                    box-shadow: 4px 0 0 rgba(167, 167, 167, 0.1);
                    position: sticky;
                    left: 0;
                    z-index: 9999;
                    background-color: white;
                    ">
                </div>
                <div class="product-header" style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);width:50px">
                  <b-card class="custom-card" @click="openModal('telkom')">
                    <div :class="{ 'dashed-border': selectedCategory === '', 'no-border': selectedCategory !== '' }">
                      <b-card-text class="b-card-text">
                        <b-img :src="telkomImg" class="img-logo" />
                        <hr v-if="selectedCategory !== ''" />
                        <b-img v-if="selectedCategory === ''" :src="plusIcon" class="icon-plus" />
                        <h3 v-else class="selected-category" style="color:red; font-weight: 800"><b>{{ selectedCategory
                            }}</b></h3>
                        <p style="margin-top:10px" v-if="selectedCategory === ''" class="card-text">Choose Product</p>
                      </b-card-text>
                    </div>
                  </b-card>
                </div>
                <div class="product-header" style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px">
                  <b-card :class="{ 'custom-card disabled-card': selectedCategory === '', 'custom-card': selectedCategory !== '' }" @click="openModal('competitor', 0)">
                    <div
                      :class="{ 'dashed-border': selectedCompetitor[0] === undefined, 'no-border': selectedCompetitor[0] !== undefined }">
                      <b-card-text class="b-card-text">
                        <b-img class="img-logo" />
                        <b-img v-if="selectedCompetitor[0] !== undefined" @click.stop="removeCompetitor(0)" :src="xIcon"
                          style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                          alt="Remove Competitor" />
                        <b-img v-if="disabledIcon === true" :src="plusDisabledIcon" style="width: 45px;margin-top: 34px" />
                        <b-img v-else-if="disabledIcon === false && selectedCompetitor[0] === undefined" :src="plusDis" style="width: 45px;margin-top: 25px" />
                        <b-img style="margin-top:35px"
                          v-else="disabledIcon === false && selectedCompetitor[0] !== undefined"
                          :src="getCompetitorImage(competitorData[0].competitorName.key)"
                          class="selected-category img-logo-competitor" alt="Selected Competitor" />
                        <p style="margin-top:10px" v-if="selectedCompetitor[0] == undefined">Choose Competitor</p>
                      </b-card-text>
                    </div>
                  </b-card>

                </div>
                <div 
                  class="product-header" 
                  style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px"
                  v-for="(competitor, index) in competitorData.slice(1)" 
                  :key="index">
                  <b-card class="custom-card" @click="openModal('competitor', index + 1)">
                    <div
                      v-if="selectedCompetitor[index] !== undefined"
                      :class="{ 'dashed-border': !selectedCompetitor[index], 
                      'no-border': selectedCompetitor[index] }">
                      <b-card-text class="b-card-text">
                        <b-img class="img-logo" />
                        <b-img 
                          v-if="selectedCompetitor[index]" 
                          :src="xIcon" alt="Remove Competitor"
                          class="icon-x"
                          style="position: absolute; top: 10px; right: 10px; cursor: pointer; width:25px"
                          @click.stop="removeCompetitor(index + 1)" />
                        <b-img 
                          v-else 
                          :src="plusDis" 
                          style="width: 45px;margin-top: 34px" />
                        <b-img 
                        v-if="competitor && competitor.competitorName" 
                        style="margin-top:35px"
                        :src="getCompetitorImage(competitor.competitorName.key)" 
                        class="selected-category img-logo-competitor" alt="Selected Competitor" />
                        <p 
                          style="margin-top:10px"
                          v-if="!selectedCompetitor[index]">
                          Choose Competitor
                        </p>
                      </b-card-text>
                    </div>
                  </b-card>
                </div>
                <div 
                  class="product-header" 
                  style="box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); width:50px"
                  v-if="showAddCompetitorCard">
                  <b-card class="custom-card" @click="openModal('competitor', selectedCompetitor.length)">
                    <div class="dashed-border">
                      <b-card-text class="b-card-text">
                        <b-img :src="plusDis" style="width: 45px;margin-top: 34px" />
                        <p style="margin-top:10px">Choose Competitor</p>
                      </b-card-text>
                    </div>
                  </b-card>
                </div>
              </div>

              <div class="comparison-row sticky-card"
                v-for="(value, key) in comparisonData[Object.keys(comparisonData)[0]]" v-if="hasComparisonData">
                <div class="label" v-if="!shouldHideLabel(formatKey(key))">
                  <p><b v-html="formatKey(key)"></b></p>
                </div>
                <div v-if="!shouldHideLabel(formatKey(key))" class="value" v-for="(provider, index) in comparisonData">
                  <b-input-group class="mb-2">
                    <b-form-input 
                      :id="'input-value-' + index" 
                      v-model="provider[formatKey(key)]"
                      required>
                    </b-form-input>
                    <b-form-select
                      v-if="showOptionsForServiceType(key)"
                      :options="getOptionsForCategory(key)"
                      v-model="select"
                      :id="'select-value' + index">
                    </b-form-select>
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
      <div class="d-flex justify-content-center">
        <b-button v-if="hasComparisonData" @click="resetCompare" variant="primary">
          Update Comparison Data
        </b-button>
      </div>
    </div>
    <div>
      <div v-if="!hasComparisonData" class="d-flex justify-content-center mt-3">
        <b-button @click="handleCompare" class="w-25" variant="primary">Compare</b-button>
      </div>
    </div>
    <b-modal modal-class="modal-product" title="Choose Product" v-model="isModalOpen">
      <b-form-group>
        <b-form-select v-model="selectedOption" :options="categoriesProduct"></b-form-select>
      </b-form-group>
      <template #modal-footer>
        <div class="text-center gap-2 w-100">
          <b-button variant="secondary" @click="isModalOpen = false" class="mr-2">Close</b-button>
          <b-button variant="primary" @click="selectCategory">OK</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal 
      :no-close-on-backdrop="true" 
      :no-close-on-esc="true" 
      modal-class="modal-competitor" 
      v-model="isModalCompetitor" 
      title="Choose Competitor">
      <b-col cols="12" sm="12" lg="12">
        <b-form-group>
          <v-select
            v-model="selectedCompetitorOptions"
            multiple
            :options="categoriesCompetitors.filter(cc => !cc.disabled)"
            :close-on-select="false"
            />
        </b-form-group>
      </b-col>
      <b-col v-if="selectedCompetitorOptions ? selectedCompetitorOptions.length > 0 : false"
        cols="12"
        md="12"
        class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
      >
      </b-col>
      <template #modal-footer>
        <div class="text-center w-100">
          <b-button variant="secondary" @click="isModalCompetitor = false" class="mr-2">Close</b-button>
          <b-button style="background-color:#10375C !important" @click="selectedCompetitors">OK</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardText, BImg, BCardGroup, VBModal, BFormSelect, BFormGroup, BButton, BRow, BCol, BContainer, BTable, BFormTags, BFormInput,BInputGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { generateToken } from '@/auth/helperAuth'
export default {
  components: { BCard, BCardText, BImg, BCardGroup, VBModal, BFormSelect, BFormGroup, BButton, BRow, BCol, BContainer, BTable, BFormTags, vSelect, BFormInput, BInputGroup },
  data() {
    return {
      telkomImg: require('@/assets/images/logo_telkom horizontal.png'),
      plusIcon: require('@/assets/images/icons/adds.png'),
      plusDis: require('@/assets/images/icons/plusDis.png'),
      plusDisabledIcon: require('@/assets/images/icons/disabledPluss.png'),
      xIcon: require('@/assets/images/icons/remove.png'),
      disabledIcon: true,
      isModalOpen: false,
      isModalCompetitor: false,
      selectedOption: '',
      selectedCategory: '',
      selectedCompetitorOptions: '',
      selectedCompetitor: [],
      categoriesCompetitors: [],
      categoriesProduct: [],
      competitorData: [],
      currentCardIndex: null,
      comparisonData: {},
      showAddCompetitorCard: false,
      serviceOptions: {},
      token: ""
    }
  },
  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },
  mounted() {
    Promise.all([
      this.categories()
    ])
  },
  computed: {
    hasComparisonData() {
      return Object.keys(this.comparisonData).length > 0
    },
  },
  methods: {
    showOptionsForServiceType(serviceType) {
      const data = [
        'Delivery Time (working days)',
        'Bandwidth',
        'Promised SLA',
        'Minimum Contract'
      ]
      return data.includes(serviceType)
    },
    getOptionsForCategory(serviceType) {
      return this.serviceOptions[serviceType] || []
    },
    shouldHideLabel(label){
      const hiddenLabels = ['label']
      return hiddenLabels.includes(label)
    },
    shouldHighlight(key, value){
      if(this.selectedCategory == 'SD-WAN'){
        if(key['label'] == 'TELKOM'){
          if(value == 'Installation Fee (One Time Charge)'){
            return true
          }
        }
      }else{
        return false
      }
    },
    async categories() {
      let params = {
        table: "service_type",
        page: 1,
        perPage: 0,
        search: "TELKOM",
        order: 'DESC'
      }
      return await this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
        params: params,
        withCredentials: true,
        headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
      })
        .then(response => {
          console.log(response)
          const category = response.data.data.map(i=> {
            return i.name
          })
          console.log(category)
          this.categoriesProduct = category
        })
    },
    openModal(card, index = 0) {
      this.currentCardIndex = index
      if (card === 'telkom') {
        this.isModalOpen = true
      }
      else if (card === 'competitor') {
        this.isModalCompetitor = true
      }
    },
    selectCategory() {
      this.selectedCompetitor = []
      this.competitorData = []
      this.categoriesCompetitors = []
      this.selectedCompetitorOptions = ''
      let params = {
        table: "service_type",
        page: 1,
        perPage: 0,
        search: "KOMPETITOR",
        order: 'DESC'
      }
      if(this.selectedCompetitor.length == 0){
        this.showAddCompetitorCard = false
      }
      if (this.selectedCategory === '') {
        this.selectedCategory = this.selectedOption
        this.disabledIcon = false
        this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
          params: params,
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then(response => {
            for (let cc of response.data.data) {
              this.categoriesCompetitors.push({
                key: cc.name,
                label: cc.name,
              })
            }
          })
      } else if (this.selectedCategory !== '' && Object.keys(this.comparisonData).length == 0) {
        this.selectedCategory = this.selectedOption
        this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
          params: params,
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then(response => {
            for (let cc of response.data.data) {
              this.categoriesCompetitors.push({
                key: cc.name,
                label: cc.name,
              })
            }
          })
      } else if (this.selectedCategory !== '' && Object.keys(this.comparisonData).length > 0) {
        this.comparisonData = {}
        this.selectedCompetitor = []
        this.competitorData = []
        this.categoriesCompetitors = []
        this.selectedCompetitorOptions = ''
        this.selectedCategory = this.selectedOption
        this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list`, {
          params: params,
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then(response => {
            for (let cc of response.data.data) {
              this.categoriesCompetitors.push({
                key: cc.name,
                label: cc.name,
              })
            }
          })
        const requestData = {
          category: this.selectedOption,
          competitor: ['TELKOM']
        }
        this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison/list`, requestData, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then(res => {
            this.comparisonData = res.data
          })
          .catch(error => {
            console.error('Error fetching comparison data:', error)
          })
      }
      this.isModalOpen = false
    },
    formatKey(key) {
      return key.replace(/\n/g, '<br>')
    },
    formatValue(value) {
      return value ? value.replace(/\n/g, '<br>') : '-'
    },
    getCompetitorImage(competitorKey) {
      try {
        return require(`@/assets/images/competitor/${competitorKey}.png`)
      } catch (e) {
        console.error("Gagal memuat gambar:", e)
        return require('@/assets/images/competitor/logo_telkom horizontal.png')
      }
    },
    selectedCompetitors() {
      if(this.selectedCompetitorOptions.length > 0){
        this.selectedCompetitor = [...this.selectedCompetitorOptions]
        this.selectedCompetitorOptions.forEach((competitor) => {
          if (!this.competitorData.some(data => data.competitorName === competitor)) {
            this.competitorData.push({ competitorName: competitor })
            this.selectedCompetitor = [...this.competitorData]
            this.showAddCompetitorCard = this.selectedCompetitor.length < this.categoriesCompetitors.length
          }
        })
        this.categoriesCompetitors.forEach((cc) => {
          cc.disabled = this.selectedCompetitor.some(comp => comp.competitorName.key === cc.key)
        })
        this.selectedCompetitorOptions = []
        this.isModalCompetitor = false
        if (Object.keys(this.comparisonData).length > 0) {
          this.handleCompare()
        }
        if (this.selectedCompetitor.length < this.categoriesCompetitors.length) {
          this.showAddCompetitorCard = true
        }
      }else{
        this.isModalCompetitor = false
        this.$notifOnClick(
          'Sorry!', 
          "To ensure you get the best comparison tailored to your needs, please consider our competitors' options first. Thank you for your attention.", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
      }
    },
    handleCompare() {
      const collectCompetitor = []
      this.selectedCompetitor.forEach((competitor) => {
        if (competitor) {
          collectCompetitor.push(competitor.competitorName.key)
        }
      })
      const requestData = {
        category: this.selectedOption,
        competitor: collectCompetitor
      }
      if(requestData.competitor.length > 0){
        this.$http.post(`${process.env.VUE_APP_API_HELPER_URL}/competitor/comparison/list`, requestData, {
          withCredentials: true,
          headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
        })
          .then(res => {
            console.log(res)
            let existingData = this.comparisonData;
            let newData = res.data.comparison;
            collectCompetitor.forEach((item, index) => {
              if (newData[item]) {
                newData[item].label = item
                newData['TELKOM'].label = 'TELKOM'
              }
            })
            this.comparisonData = {
              ...existingData,
              ...newData
            };
          })
          .catch(error => {
            console.error('Error fetching comparison data:', error);
          })
          this.$http.get(`${process.env.VUE_APP_API_HELPER_URL}/internal/data/list?table=service_specifications&page=1&perPage=10`, {
            withCredentials: true,
            headers: { 'Client-Device': 'browser', 'Authorization': `${this.token}` },
          })
          .then(response => { 
            this.serviceOptions = response.data.data
            .filter(item => item.format.length > 0)
            .reduce((acc, item) => {
              const options = item.format.map(format => {
                let value = format.toLowerCase().replace(/ /g, '_')
                let text = `${format}`
                return { value, text }
              })
              acc[item.name] = options
              return acc
            }, {})
          })
      }else{
        this.$notifOnClick(
          'Sorry!', 
          "To ensure you get the best comparison tailored to your needs, please consider our competitors' options first. Thank you for your attention.", 
          'danger', 
          'AlertTriangleIcon',
          'danger',
          'OK',
          () => {})
      }
    },
    resetCompare() {
      this.comparisonData = {}
      this.selectedCategory = ''
      this.selectedOption = ''
      this.selectedCompetitor = []
      this.competitorData = []
      this.categoriesCompetitors = []
      this.disabledIcon = true
      this.currentCardIndex = null
      this.isModalOpen = false
      this.isModalCompetitor = false
      this.showAddCompetitorCard = false
      this.selectedCompetitorOptions = ''
    },
    
    removeCompetitor(index) {
      this.$bvModal
        .msgBoxConfirm('Removing this competitor will delete all data related to this category. Are you sure you want to continue? Please reconsider before continuing. Thank you for your attention.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            const competitorName = this.selectedCompetitor[index]?.competitorName?.key
            this.selectedCompetitor.splice(index, 1)
            this.competitorData.splice(index, 1)
            if (competitorName && this.comparisonData[competitorName]) {
              this.$delete(this.comparisonData, competitorName)
            }
            this.categoriesCompetitors.forEach((cc) => {
              cc.disabled = this.selectedCompetitor.some(comp => comp?.competitorName?.key === cc.key)
            })
            if((Object.keys(this.comparisonData).length == 1 && this.comparisonData['TELKOM']) || this.selectedCompetitor.length == 0){
              this.showAddCompetitorCard = false
            }
            else if(this.selectedCompetitor.length < this.categoriesCompetitors.length){
              this.showAddCompetitorCard = true
            }
          }
        })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
<style scoped>
.scroll-wrapper {
  position: sticky;
}

.scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.card-container {
  display: flex;
  justify-content: center;
  white-space: nowrap;
  overflow: auto;
}

.card-container-after {
  justify-content: flex-start;
  flex-wrap: nowrap;
  margin-bottom: 20px;
}

.custom-card {
  min-width: 250px;
  height: 170px;
  overflow: hidden;
  margin: 0 1px;
  flex-shrink: 0;
  flex-grow: 0;
  cursor: pointer;
}

.disabled-card {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

.product-comparison {
  /* padding: 0; */
  /* margin: 0 auto; */
  font-family: Arial, sans-serif;
}

.comparison-table {
  display: table;
  width: 100%;
  border: none;
  border-collapse: separate;
  border-spacing: 20px;
}

.dashed-border {
  border: 1px dashed grey;
  padding: 10px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.b-card-text {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  text-align: center;
  flex-grow: 1;
}

.img-logo {
  width: 80%;
  max-height: 80px;
  object-fit: contain;
}

.img-logo-competitor {
  width: 130px;
  height: 80px;
  margin: 0 auto;
  justify-content: center;
  object-fit: contain;
  align-items: center;
  text-align: center;
}

.icon-plus {
  width: 45px;
}

.product-headers {
  display: table-row;
  margin-bottom: 20px;
}

.product-header {
  display: table-cell;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
  min-width: 50px;
}

.comparison-row {
  display: table-row;
  border-collapse: separate;
}

.comparison-row>.label,
.comparison-row>.value {
  display: table-cell;
  padding: 10px;
  background-color: #fff;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid #cecece;
  text-overflow: ellipsis;
  width: 20px;
  max-width: 250px;
}

.label>p {
  width: 170px;
  font-weight: bold;
}

.comparison-row>.label:not(:last-child),
.comparison-row>.value:not(:last-child) {
  border-right: none;
}

.comparison-row>.label {
  box-shadow: 4px 0 0 rgba(167, 167, 167, 0.1);
  text-align: left;
  position: sticky;
  left: 0;
  z-index: 99;
  background-color: white;
}

.vpn-header img {
  max-width: 200px;
  height: auto;
}

.icon-button {
  position: absolute;
  bottom: 20px;
  right: 10px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.source-bottom {
  position: absolute;
  bottom: 0;
  left: 25px;
  font-weight: 600;
  color: grey;
}


@media (max-width: 768px) {
  .comparison-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .product-header img {
    max-width: 80px;
  }
}
</style>
<style>
.vs__dropdown-option--selected,
.vs__dropdown-option--highlight,
.vs__dropdown-option:focus,
.vs__dropdown-option:hover {
  background-color: #10375C !important;
  color: white !important;
}

.vs__selected {
  background-color: #10375C !important;
  color: white !important;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}

.vs__dropdown-option--selected {
  background-color: #10375C !important;
  border-color: #10375C !important;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
  color: white !important;
}

.vs__dropdown-option--highlight {
  background-color: #10375C !important;
  color: white !important;
}

.vs__deselect {
  fill: white !important;
}

.vs__dropdown-option:hover {
  background-color: #10375C !important;
  color: white !important;
}

.vs--open .vs__dropdown-toggle {
  border-color: #10375C !important;
  border-bottom-color: #10375C !important;
  color: white !important;
}

.vs--open .vs__dropdown-menu {
  left: 0;
  text-align: left;
  color: white !important;
}
.red-text{
  color: red;
  font-weight:600;
}
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}
.modal-product .modal-header {
  background-color: #dc3545 !important;
  color: white !important;
}

.modal-competitor .modal-header {
  background-color: #10375C !important;
  color: white !important;
}

.modal-title {
  color: white;
  font-weight: 600
}
</style>